import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ConnectService {
  constructor() {}
  private apiData: any;

  setData(data: any) {
    this.apiData = data;
  }

  getData() {
    return this.apiData;
  }
}
